import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from 'src/app/services/course/course.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { AddCourseComponent } from '../add-course/add-course.component';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';
import { ConfirmationModalComponent } from '../../dialog-modal/confirmation-modal/confirmation-modal.component';
import { id } from '@swimlane/ngx-charts';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { AssignCourseComponent } from '../assign-course/assign-course.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ViewExamsheetComponent } from '../view-examsheet/view-examsheet.component';
import { MoreCourseInfoComponent } from '../more-course-info/more-course-info.component';
import { Filter } from '../../filter/filter.model';
import { PaginationInstance } from 'ngx-pagination';
import { CommonService } from 'src/app/services/common/common.service';
// Imp points::
//1)If admin is user then don't show him view course option
//2)Don't allow user to modify if it is admin course 
//3)User can export csv of user list.
@Component({
  selector: 'app-view-course',
  templateUrl: './view-course.component.html',
  styleUrls: ['./view-course.component.scss']
})
export class ViewCourseComponent {
  public boxArr: any[] = [
    { content_type: 'completed', text: "Have Completed", cont_img: "assets/images/object_icons/completed_course.svg", progress_bar_color: "green-progress" ,filterBy:"t_c"},
    { content_type: 'pending', text: "Are in progress", cont_img: "assets/images/object_icons/pending_course.svg", progress_bar_color: "orange-progress" ,filterBy:"t_p"},
    { content_type: 'not started', text: "Have not started", cont_img: "assets/images/object_icons/not_started_course.svg", progress_bar_color: "red-progress" ,filterBy:"tnsc"},
    { content_type: 'exam attended', text: "Exam Attended ", cont_img: "assets/images/object_icons/exam_attended.svg", progress_bar_color: "sky-progress",filterBy:"ex_at" },
    { content_type: 'missed deadline', text: "Missed Deadline", cont_img: "assets/images/object_icons/missed_deadline.svg", progress_bar_color: "purple-progress" ,filterBy:"m_d"}
  ]
  public dataSource = new MatTableDataSource();
  public count!: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  public imageURL: any = GlobalService.imageURL;
  public displayedColumns: string[] = ['user_info', 'completed_practical', 'certificate_access', 'manager', 'training_date',
    'deadline_date', 'department', 'course_progres', 'action'];
  // public displayedColumns: string[] = ['first_name', 'phone_number', 'date_added', 'action'];
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public courseId: any;
  private packageId: any;
  public isAdmin: boolean = false;
  public courseStatistics: any = {}
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", }
  @ViewChild(MatSort) sort!: MatSort;
  pageIndex = 0;
  pageSize = 15;
  public courseData: any;
  public courseName!: string;
  public isAdminCourse: boolean = false;
  public serverURL = GlobalService.serverURL;
  public selectedFilter!:string;
  public isFilterShow :boolean=false;
  public filterObj:Filter={
    operand:"or",
    arr:[]
  }
  public filterArr:any[]=[
    { key_name: "First Name", key_val: "first_name", type: 'text' },
    { key_name: "Last Name", key_val: "last_name", type: 'text' },
    { key_name: "Email", key_val: "employee_information.email", type: 'text' },
    { key_name: "Department", key_val: "dep", type: 'select' },
    { key_name: "Training Date", key_val: "tr_dt", type: 'date' },  
    { key_name: "Deadline Date", key_val: "de_dt", type: 'date' },
  ]
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public courseType!:string;
  public searchInput: string = '';
  private previousInputValue: string = '';
  @ViewChild('targetElement') targetElement!: ElementRef;
  isPageInitiated:boolean = false;
  constructor(private _liveAnnouncer: LiveAnnouncer, private courseService: CourseService, private appService: AppService, private spinner: NgxSpinnerService,
  private activatedRoute: ActivatedRoute, private dialog: MatDialog,private commonService:CommonService,private router:Router) {}

  ngOnInit(): void {
    this.commonService.setTitle("Course Management")
    this.isPageInitiated=true;
    this.checkUserType()
    this.boxArr.map(item=>{item["selected"]=''})
    this.boxArr[0].selected=true;
    this.selectedFilter=this.boxArr[0].filterBy
    this.activatedRoute.queryParams.subscribe(params => {
      if (params["id"]) {
        this.courseId = params["id"];
        this.packageId = params["package_id"]
        if (params && this.appService.getDecryptedText(params["ad_c"]) == 'yes') {
          this.isAdminCourse = true;
        }
        this.courseType=params["t"]
        this.onViewCourse(params["id"], 'company', this.packageId)
      }
    })
  }
  onFilterView(){
    this.isFilterShow = !this.isFilterShow;
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.onViewCourse(this.courseId, 'company', this.packageId)
  }
  onPageChange(number: number) {
    if(this.isPageInitiated){
      this.isPageInitiated = false;
      return;
    }
    this.config.currentPage = number;
    this.onViewCourse(this.courseId, 'company', this.packageId)
  }
  callApi(obj){
    this.filterObj=obj    
    this.onViewCourse(this.courseId, 'company', this.packageId)
  }
  onBoxSelected(item){
    this.selectedFilter=item.filterBy
    item.selected = true;
    this.boxArr.forEach(i => {
      if (i !== item) {
        i.selected = false;
      }
    });
    if(window.innerWidth< 576){
      this.targetElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }    
    this.onViewCourse(this.courseId, 'company', this.packageId)
  }
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  onViewCourse(id: any, login_type: any, p_id: any) {
    let obj = {
      pc_i: p_id,
      c_i: id,
      login_type: login_type,
      filter_by:this.selectedFilter,
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      sh:this.searchInput.trim(),
      op_nd:this.filterObj.operand,
      f_a:this.filterObj.arr
    }
    this.spinner.show()
    this.courseService.viewCourse(obj).subscribe({
      next: (success: any) => {
      if(success.status==200){
        this.previousInputValue=this.searchInput
        this.spinner.hide()
        this.dataSource.data =success["msg"]["user_data"]
        this.courseStatistics = success["msg"]["course_progress_detail"]
        this.count = success["msg"].count;
        this.courseData = success["msg"]
        this.courseName = success["msg"]["course_name"]
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.calculatePercentage()
      }},
      error:(error:any)=>{
        this.commonService.handleError(error)
       }})
  }
  calculatePercentage() {
    let value: any;
    this.boxArr.map((item: any) => {
      let content_type = item["content_type"];
      if (content_type == 'completed') {
        value = this.courseStatistics.total_completed
      }
      if (content_type == 'pending') {
        value = this.courseStatistics.total_progress
      }
      if (content_type == 'not started') {
        value = this.courseStatistics.total_not_started_course
      }
      if (content_type == 'exam attended') {
        value = this.courseStatistics.total_attend_exam
      }
      if (this.courseStatistics.total_assign_course > 0) {
        item["percentage"] = ((value / this.courseStatistics.total_assign_course) * 100).toFixed(2);
      }
      else {
        item["percentage"] = 0;
      }
    })
  }
  onEditCourse() {
    let item = {}
    item["c_i"] = this.courseId
    // edit button is getting enabled only if it is company course else it will not be displayed.
    //hence i am giving here the c_type which is company type as 1 by default.
    item["c_type"] =1
    item["t"]=this.courseType
    const dialogRef = this.dialog.open(AddCourseComponent, {
      width: '96%',
      height: '94%',
      maxWidth: '100vw',
      panelClass: 'addCourseModal',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      data: { data: item }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  onPageEvent = (event: any) => {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    let startPage = (event.pageIndex) * (event.pageSize) + 1;
  }
  checkUserType() {
    if (this.appService.getSessionData('isAdmin')) {
      // this screen will never be used by admin so commenting the below line
      // this.isAdmin = this.appService.getSessionData('isAdmin');
    }
    // this.appService.storeData('training-portal.authToken',this.cookieService.get('user_id'));
    // this.appService.storeData('isAdmin',JSON.stringify(true));
  }
  changeCertifcateAccess(value: any, item: any) {
    let dataObj: any = {}
    dataObj["a_ci"] = item["a_ci"]
    dataObj["em_i"] = item["em_i"]
    dataObj["is_build"] = item["is_build"]
    // dataObj["m_c_g"] = !value["checked"]
    dataObj["m_c_g"] = value["checked"]
    dataObj["is_e"] = item["is_e"]
    dataObj["is_pr"] = item["is_pr"]
    dataObj["t"]=this.courseType
    value.source.checked = !value.source.checked
    this.confirmationAlert(dataObj, 'certificate access')
  }
  changeCoursePractical(value: any, item: any) {
    let dataObj: any = {}
    dataObj["a_ci"] = item["a_ci"]
    dataObj["em_i"] = item["em_i"]
    dataObj["is_build"] = item["is_build"]
    dataObj["m_c_g"] = item["m_c_g"]
    dataObj["is_e"] = item["is_e"]
    dataObj["is_pr"] = value["checked"]
    dataObj["t"]=this.courseType
    // doing this so value does not get checked untill it is confirmed using confirmation dialog boxes.
    value.source.checked = !value.source.checked
    this.confirmationAlert(dataObj, 'course practical')
  }
  confirmationAlert(dataObj: any, content_type: any) {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: { dataObj, content_type: content_type }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["confirm_yes"] == true) {
          this.onViewCourse(this.courseId, 'company', this.packageId)
        }
      }
      if (result == undefined) {
        // if(content_type=='course practical'){
        //   return dataObj
        // }
      }
    });
  }
  onDeleteItem(item: any) {
    let dataObj: any = {}
    dataObj["a_ci"] = item["a_ci"]
    dataObj["t"]=this.courseType
    const dialogRef = this.dialog.open(DeleteItemComponent,
      Object.assign({ data: { content_type: "delete_assign_user", api_type: "delete_content", dataObj: dataObj, } }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["delete_content"] == true) {
          this.onViewCourse(this.courseId, 'company', this.packageId)
        }
      }
    });
  }
  onAssignCourse() {
    // course can also be assigned from course dashboard
    let obj = {
      "is_builder": this.courseData["is_build"],
      "is_editable": this.courseData["is_e"],
      "course_id": this.courseId,
      "package_course_id": this.packageId,
      "t":this.courseType
    }
    const dialogRef = this.dialog.open(AssignCourseComponent, Object.assign({
      width: '80%', height: '95%', maxWidth: '100vw',
      data: { data: obj }
    }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["course_assigned"] == true) {
        this.onViewCourse(this.courseId, 'company', this.packageId)
      }
    });
  }
  onExportCSV() {
    if (this.dataSource.data.length > 0) {
      this.spinner.show()
      let data: {} = {
        "course_id": this.courseId,
        "login_type": "company",
        "package_course_id": this.packageId
      }
      this.courseService.onViewCourseCSV(data).subscribe({
        next: (success: any) => {
        this.spinner.hide();
        if (success.status == 200) {
          window.open(this.serverURL + success.msg);
        }
      },
      error:(error:any)=>{
        this.commonService.handleError(error)
       }
    });
    }

  }
  doFilter = (event: any) => {
    let newVal = event.target?.value
    this.dataSource.filter = newVal.trim().toLocaleLowerCase();
  }
  onViewExamSheet(element: any) {
    const dialogRef = this.dialog.open(ViewExamsheetComponent,
      Object.assign({ data: { data: element } }, this.animationConfig, { width: '70%', minWidth: '280px', maxWidth: "800px" }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
  onMoreInfo(element) {
    const dialogRef = this.dialog.open(MoreCourseInfoComponent,
      Object.assign({ data: { data: element } }, this.animationConfig, { width: '50%', minWidth: '280px', maxWidth: "800px" }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
  onCertificateDownload(element: any) {
    this.appService.downloadFile(element.c_img, 'certificate.png')
  }
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.onViewCourse(this.courseId, 'company', this.packageId)
    }
  }
  onGo(){
    if(this.dataSource.data.length === 0){
      return;
    }
    if(this.searchInput.trim()!=''){
      this.onViewCourse(this.courseId, 'company', this.packageId)
    }
  }
  onBack(){
    if(window.location.href.includes('dashboard')){
      this.router.navigate(['/course/dashboard'])
    }
    else{
      this.router.navigate(['/course/builder'])
    }
  }
}
